export default __webpack_public_path__ + "static/media/table.c2efd264.png";